import car from './car'
import orderProperties from './order-properties'
import reason from './reason'
import organization from './organization'
import feedback from './feedback'
import crm from './crm'
import financial from './financial'
import cms from './cms'
import geo from './geo'
import unit from './unit'
import feature from './feature'
import calendar from './calendar'
import user from './user'
import courier from './courier'
import club from './club'
import contract from './contract'
import questionnaire from './questionnaire'
import poi from './poi'
import addon from './order-properties/addon'
import loadCondition from './order-properties/load-condition'

export default {
  name: 'BaseInfo',
  path: 'base-info',
  meta: {
    label: 'BaseInfo',
    auth: 'baseInfo'
  },
  component: {
    name: 'BaseInfo',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    car,
    orderProperties,
    reason,
    organization,
    feedback,
    crm,
    financial,
    cms,
    geo,
    unit,
    feature,
    calendar,
    user,
    courier,
    club,
    contract,
    questionnaire,
    poi,
    addon,
    loadCondition
  ]
}
